export const getTrailingSlashUrl = (url) => {
  if (url) {
    if (!url.endsWith("/")) {
      return `${url}/`;
    }
  }
  return url;
};

export const getQueryParamsFromUrl = (url) => {
  const { queryParams: query } = url || {};
  return query === null ? "" : query;
};

export const getBasePathFromUrl = (url, isProjectPage) => {
  const { basePath } = url || {};
  if (isProjectPage && !basePath?.includes("/projeler/")) {
    const projectPagePath = basePath?.concat("projeler/");
    return projectPagePath;
  }
  return basePath;
};

export const createPaginationUrl = ({ url, page, isProjectPage }) => {
  const pageNumber = parseInt(page, 10);
  const basePath = getBasePathFromUrl(url, isProjectPage);
  const trailingSlashUrl = getTrailingSlashUrl(basePath);
  const queryParams = getQueryParamsFromUrl(url);

  if (pageNumber === 1 || pageNumber === 0) {
    return `${basePath}${queryParams && queryParams}`;
  }
  return `${trailingSlashUrl}${pageNumber}${queryParams && queryParams}`;
};

export const normalizeUrl = (url, trailing = true) => {
  if (url) {
    let baseUrl = url.split("?")[0];
    let query = url.split("?")[1];
    const regexUrl =
      /^\/(satilik-[a-z-]+|kiralik-[a-z-]+|gunluk-kiralik-[a-z-]+|kat-karsiligi-arsa|devren-isyeri)(\/[^/]*)*\/?$/;
    const regexForLandingPage = /^\/([a-zA-Z0-9-]+(?:\/[a-zA-Z0-9-]+)*\-lp\/?)$/;
    if (regexUrl.test(url) || regexForLandingPage.test(url)) {
      if (baseUrl.endsWith("/")) {
        baseUrl = baseUrl.slice(0, -1);
      }
      return query ? `${baseUrl}?${decodeURIComponent(query)}` : `${baseUrl}`;
    }
    if (baseUrl.substr(-1) !== "/") {
      return query ? `${baseUrl}/?${decodeURIComponent(query)}` : trailing ? `${baseUrl}/` : `${baseUrl}`;
    }
    return url;
  }
  return url;
};
export const addParameterToURL = (param, url) => {
  if (typeof url !== "string") return "";
  if (url.includes(param)) return url;
  const isMapView = param === "view_type=map" || url.includes("bottom_left");
  return isMapView
    ? `${url}${url.split("?")[1] ? "&" : "?"}view_type=map`
    : `${url}/${url.split("?")[1] ? "&" : "?"}view_type=map`;
};

export const isListingUrlControl = (param) => {
  const controller = /^(?!\/ilan)\/(satilik|kiralik|kat-karsiligi|devren|gunluk-kiralik)-([A-Za-z0-9\\-\\.]+)(\/)?.*/;
  return controller.test(param);
};

export const getUrlEncodedComponent = (component) => encodeURIComponent(component);

export const getOdaAiScriptUrl = (listingId, phoneNumber) => {
  if (!listingId || !phoneNumber) return;
  const odaAiUrl = "https://partner-dev.odaportal.workers.dev/";
  const urlEncodedPhoneNumber = getUrlEncodedComponent(phoneNumber);
  return `${odaAiUrl}?partner=emlakjet&listing_id=${listingId}&phone=${urlEncodedPhoneNumber}`;
};
